/**
 * 描述：树列表 节点
 */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SwTreeNodeOptions } from './sw-tree-node';
import { SwHttpClientService } from 'src/app/librarys/serves/sw-http-client.service';
import { SystemIdService } from 'src/app/librarys/serves/public/system-id.service';


/**
 * 用于树的递归
 */
@Component({
  selector: 'sw-tree-node',
  templateUrl: './sw-tree-node.component.html',
  styleUrls: ['./sw-tree-node.component.css']
})
export class SwTreeNodeComponent implements OnInit {

  /**
   * 当前的节点和它的子节点组成的树结构
   */
  @Input() node: SwTreeNodeOptions;   

    /**
   * 传入的地址如果为bdp相关，需要再请求中加入此参数
   */
  @Input() isAdminQuery: boolean;
  /**
   * 选中的key值
   */
  @Input() keySelected: string; 

  /**
   * 异步加载的请求地址
   */
  @Input() asyncNodeUrl: string;  

  /**
   * 异步请求1： 2：
   */
  @Input() asyncParams: string; 

  /**
   * 主键
   */
  @Input() id:string; 

  /**
   * 父主键
   */
  @Input() pid:string; 
  
  /**
  * 节点类型输入 1,文件类型  2,用户类型 , 现在还只是在用户管理中用到, 根据positionId判断,如果positionId存在, iconType 就为2 , 没有就为1
  */
  @Input() type: string; 

  /**
   * 显示
   */
  @Input() text:string; 

  //是否显示岗位
  @Input() showPos:boolean;
  /**
   * 单选功能--传出选中节点
   */
  @Output() voted = new EventEmitter();  

  /**
   * 最底层节点复选框功能--传出选中节点(多选) 
   */
  @Output() votedMulti = new EventEmitter();  

  /**
   * 最底层节点复选框功能--传出取消选中节点(多选)
   */
  @Output() votedMultiCancel = new EventEmitter(); 

  /**
   * 所有节点复选框功能--传出选中节点(多选)
   */
  @Output() votedCheck = new EventEmitter();  

  /**
   * 所有节点复选框功能--传出取消选中节点(多选)
   */
  @Output() votedCheckCancel = new EventEmitter(); 

  /**
   * @ignore
   * @param http 
   * @param jwt 
   */
  constructor(private http: SwHttpClientService,
              private system: SystemIdService,) {}
  /**
   * @ignore
   */
  ngOnInit(): void{
  }

  /**
   * 拿系统id
   * @ignore
   */
  systemId = this.system.getSystemId();

  /**
   * @ignore 
   */
  onExpand(nodekey:string){
    this.systemId =this.system.getSystemId();
    //判断如果是展开的节点 且下级没有数据，就不让他继续点击了
    if(this.node.expanded && this.node.children.length==0){
      this.node.expanded= true;
      return false;
    }
    //如果是异步加载 切没有展开 下级没有数据执行查询获取下级数据
    if ( this.asyncNodeUrl && !this.node.expanded && this.node.children.length == 0) {
      //通过节点的id 去查询他的下级数据
      //let  params = {"entity":{parentId:nodekey, systemId:this.systemId},"param":{pageSize:0 }};
      let str = `{"entity":{"${this.pid}":"${nodekey}", "systemId": "${this.systemId}"},"param":{"pageSize":"0" }}`;
      if(this.isAdminQuery==true){
        str = `{"entity":{"${this.pid}":"${nodekey}", "systemId": "${this.systemId}"},"param":{"pageSize":"0","isAdminQuery":true }}`;
      }
      let params = JSON.parse(str);
      this.http.Post(this.asyncNodeUrl, params).subscribe(data => {
           let nodes:any=[];
           //判断查询是否成功
           if(data["code"]==200){
             //获取的数据不为空
             if(data["data"]["records"] !=null){
               //展开节点
              this.node.expanded = !this.node.expanded;
              data["data"]["records"].forEach(el => {
                //将数据循环传入
                let nd:any={};
                nd.key= el[this.id];
                nd.title =el[this.text];
                nd.parent =el[this.pid];
                nd.data = el;
                let t = el[this.type] ? 2 : 1
                nd.iconType = t;
                nd.children=[];
                if(el["positionId"]){
                  nd.type=2
                }else{
                  nd.type=1
                }
                //如果展示岗位则加入数组
                if(this.showPos==true){
                  nodes.push(nd);
                }else if(nd.type==1){
                  nodes.push(nd);
                } 
                //nodes.push(nd);
              });
              this.node.children = nodes;
             }else{
               //下级没有数据 展开
              this.node.expanded =true
             }
        
           }
        
      })  
    }else{
      //当前节点展开切换
      this.node.expanded = !this.node.expanded;
    }
     return false; //防止事件冒泡
  }

  /**
   * 选中样式绑定
   * @ignore
   * @param key 
   */
  isSelected(key: string) {
    return key === this.keySelected;  //选中样式绑定
  }


  /**
   * 点击节点文本事件，
   * @param node 
   * @ignore
   */
  onClickVoted(node: SwTreeNodeOptions) {
    if(node.readonly){
      return
    } else {
      if(node.multiple && node.children.length == 0){  //如果是多选的时候直接选中节点
        let target = event.target as HTMLTextAreaElement
        let span2 = target.previousElementSibling.previousElementSibling as HTMLTextAreaElement
        if(span2.style.zIndex == "1"){  //如果勾选的span 层级为1,说明还未勾选,就手动调用勾选事件
          this.selectNodes(node)  //手动调用勾选事件
        } else if(span2.style.zIndex == "2"){  //如果勾选的span 层级为2,说明已经勾选,就手动调用取消勾选事件
          this.cancelSelectNodes(node)  //手动调用取消勾选事件
        } 
        
      } else if(node.checkbox){
        let target = event.target as HTMLTextAreaElement
        let span2 = target.previousElementSibling.previousElementSibling as HTMLTextAreaElement
        if(span2.style.zIndex == "1"){  //如果勾选的span 层级为1,说明还未勾选,就手动调用勾选事件
          this.checkNodes(node)  //手动调用勾选事件
        } else if(span2.style.zIndex == "2"){  //如果勾选的span 层级为2,说明已经勾选,就手动调用取消勾选事件
          this.cancelCheckNodes(node)  //手动调用取消勾选事件
        }
      } if(!node.multiple && !node.checkbox){  //两种多选功能都不是,就是单选的情况
        event.stopPropagation();
        this.voted.emit(node);
      }
    }
  }

  /**
   * 最底层节点复选框功能--点击空的复选框,进行选中操作
   * @param node 
   * @ignore
   */
  selectNodes(node: SwTreeNodeOptions){
    if(node.readonly){
      return
    } else {
      //点击想选中,根据 selected 自动调整层级
      node.selected = true
      event.stopPropagation();
      this.votedMulti.emit(node);  //将选中的节点抛出
    }
  }

   /**
   * 最底层节点复选框功能--点击已经勾选的复选框,进行取消选中操作
   * @param node 
   * @ignore
   */
  cancelSelectNodes(node: SwTreeNodeOptions){
    if(node.readonly){
      return 
    } else {
      //点击想取消选中,根据 selected 自动调整层级
      node.selected = false
      event.stopPropagation();
      this.votedMultiCancel.emit(node);  //将取消选中的节点抛出
    }
  }

  /**
   * 所有节点复选框功能--点击空的复选框,进行选中操作
   * @param node 
   * @ignore
   */
  checkNodes(node: SwTreeNodeOptions){
    if(node.readonly){
      return
    } else {
      this.checkAllChildren(node)  //调用递归的方法将此节点及其所有下级选中
      event.stopPropagation();
      this.votedCheck.emit(node);  //将选中的节点抛出
    }
  }

  /**
   * 递归的方法将此节点及其所有下级选中
   * @param node 
   * @ignore
   */
  checkAllChildren(node){
    //点击想选中,根据 selected 自动调整层级
    node.selected = true
    if(node.children.length){
      node.children.forEach(child => {
        //点击想选中,根据 selected 自动调整层级
        child.selected = true
        if(child.children.length){
          this.checkAllChildren(child)
        }
      });
    }
  }

  /**
   * 所有节点复选框功能--点击选中的复选框,进行取消选中操作
   * @param node 
   * @ignore
   */
  cancelCheckNodes(node: SwTreeNodeOptions){
    if(node.readonly){
      return 
    } else {
      //点击想取消选中,根据 selected 自动调整层级
      this.cancelAllChildren(node)
      event.stopPropagation();
      this.votedCheckCancel.emit(node);  //将取消选中的节点抛出
    }
  }

  /**
   * 递归的方法将此节点及其所有下级取消选中
   * @param node 
   * @ignore
   */
  cancelAllChildren(node){
    //点击想取消选中,根据 selected 自动调整层级
    node.selected = false
    if(node.children.length){
      node.children.forEach(child => {
        //点击想取消选中,根据 selected 自动调整层级
        child.selected = false
        if(child.children.length){
          this.cancelAllChildren(child)
        }
      });
    }
  }
}
